<template>
  <no-ssr>
    <div class="booking-popup" :class="{ '_popup-visible': popupVisible }">
      <transition name="fade" mode="out-in">
        <form
          v-if="offers.length && offer.id"
          class="booking-popup__form"
          @submit.prevent="onSubmit('Tour detail')"
        >
          <div class="booking-popup__wrapper">
            <div
              v-scroll-lock="popupVisible"
              class="booking-popup__wrapper-container"
            >
              <template v-if="sizeMdMax">
                <div
                  class="booking-popup__title font-h2 u-text-center"
                  v-html="$t('bookingPopup.popupTitle')"
                ></div>
                <button
                  type="button"
                  class="booking-popup__close u-clickable"
                  @click="popupOpen = false"
                >
                  <svg-inline
                    class="u-decor u-text-secondary u-stroke-deep-current"
                  >
                    <icon icon="close" />
                  </svg-inline>
                </button>
              </template>
              <template v-else-if="!outOfPlaces">
                <div v-if="isShowMinPrice" class="booking-popup__prices" @click="scrollToImportant">

                  <div class="booking-popup__prices-result font-h0">
                    <template v-if="customOfferSelected || (isShowMinPrice && !offerSelected)"
                    > {{ $t("bookingPopup.from") }} </template
                    >{{ symbol }} {{ priceResultFormatted }}
                  </div>

                  <div
                    v-if="hasDiscount"
                    class="
                      booking-popup__prices-original
                      font-h0
                      u-text-secondary
                    "
                  >
                    {{ priceOriginalFormatted }}
                  </div>

                  <div
                    v-if="hasDiscount"
                    class="booking-popup__prices-discount"
                  >
                    {{ offer.discountValue }}
                  </div>
                </div>



                <div v-else class="booking-popup__prices" @click="scrollToImportant">
                  <div
                    v-if="hasDiscount"
                    class="
                      booking-popup__prices-original
                      font-h0
                      u-text-secondary
                    "
                  >
                    {{ priceOriginalFormatted }}
                  </div>
                  <div class="booking-popup__prices-result font-h0">
                    <template v-if="customOfferSelected"
                      >{{ $t("bookingPopup.from") }} </template
                    >{{ symbol }} {{ priceResultFormatted }}
                  </div>
                  <div
                    v-if="hasDiscount"
                    class="booking-popup__prices-discount"
                  >
                    {{ offer.discountValue }}
                  </div>
                </div>
                <div
                  v-if="installmentAvailable"
                  class="booking-popup__installment font-text"
                  @click="triggerInstallmentPopup()"
                >
                  <span>
                    {{
                      $t("bookingPopup.installment.tooltip", {
                        symbol,
                        from: installmentPriceFormatted,
                      })
                    }}
                  </span>
                  <tooltip wrap-after-text></tooltip>
                  <popup-installment v-model="popups.installment" />
                </div>
                <div class="booking-popup__days font-semibold u-text-secondary">
                  <template v-if="!installmentAvailable">
                    <div>
                      <span class="u-text-black"
                        >{{ symbol }} {{ priceDayFormatted }}</span
                      >
                      /
                      {{ $t("bookingPopup.day") }}
                    </div>
                    <divider-dot class="u-text-secondary" />
                  </template>
                  <div>
                    {{
                      (installmentAvailable
                        ? $t("bookingPopup.duration")
                        : "") + $tc("common.days", days)
                    }}
                  </div>
                  <template v-if="offer.s7Miles && offer.s7cobranding">
                    <div class="booking-popup__c7">
                      <span>
                        <svg width="40" height="12" viewBox="0 0 40 12" fill="none" xmlns="http://www.w3.org/2000/svg">>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.98595 4.58453H3.92807C4.91141 4.58453 5.42862 4.05593 5.42862 3.23789C5.42862 2.39584 4.88546 1.91709 3.95292 1.91709H1.98595V4.58453ZM4.10876 0.331299C5.18298 0.331299 5.98484 0.633748 6.528 1.17442C7.04616 1.69048 7.35675 2.39584 7.35675 3.22628C7.35675 4.92475 6.20546 6.06942 4.2635 6.06942H1.98595V9.21592H0.0449219V0.331299H4.10876ZM14.2385 2.02361H12.518V0.331299H14.2385V2.02361ZM9.56327 3.94572H9.52349V2.94332H7.78686V9.21592H9.58984V6.15919C9.58984 4.83833 10.4388 4.26418 11.619 4.37413H11.6578V2.91879C11.5515 2.88255 11.4318 2.86977 11.2345 2.86977C10.4388 2.86977 9.97436 3.23678 9.56327 3.94572ZM12.518 9.21592H14.2385V2.86977H12.518V9.21592ZM18.5395 4.15621C19.6056 4.15621 20.209 5.00525 20.209 6.25422C20.209 7.5035 19.6056 8.33949 18.5395 8.33949C17.4607 8.33949 16.8702 7.5035 16.8702 6.25422C16.8702 5.00525 17.4607 4.15621 18.5395 4.15621ZM18.5395 2.86977C16.4978 2.86977 15.0987 4.34366 15.0987 6.25422C15.0987 8.16555 16.4978 9.63898 18.5395 9.63898C20.5815 9.63898 21.9804 8.16555 21.9804 6.25422C21.9804 4.34366 20.5815 2.86977 18.5395 2.86977ZM24.5771 3.94572H24.6172C25.0272 3.23678 25.4917 2.86977 26.2862 2.86977C26.4857 2.86977 26.6052 2.88255 26.7116 2.91879V4.37413H26.6706C25.4917 4.26418 24.6437 4.83833 24.6437 6.15919V9.21592H22.8406V2.94332H24.5771V3.94572ZM28.8621 2.02361H27.1417V0.331299H28.8621V2.02361ZM27.1417 9.21592H28.8621V2.86977H27.1417V9.21592ZM30.2244 2.76317H29.2922V3.89312H30.2244V7.6715C30.2244 8.88855 31.182 9.21592 32.0485 9.21592C32.7562 9.21592 33.1632 9.19029 33.1632 9.19029V7.93495C33.1632 7.93495 32.8615 7.94762 32.6389 7.94762C32.245 7.94762 31.9698 7.78438 31.9698 7.30781V3.89312H33.1236V2.76317H31.9698V0.754376H30.2244V2.76317ZM34.2871 10.0015H34.9153C35.6221 10.0015 35.9098 9.65406 35.9098 9.13209C35.9098 8.78403 35.7796 8.37364 35.3998 7.40441L33.5933 2.86977H35.4645L36.4592 5.74015C36.6681 6.3245 36.8913 7.13171 36.8913 7.13171H36.9176C36.9176 7.13171 37.1003 6.3245 37.3092 5.74015L38.2525 2.86977H40.0449L37.7022 9.40522C37.1922 10.8217 36.6944 11.3313 35.3332 11.3313H34.2871V10.0015Z" fill="white"/>
</svg>  +{{ offer.s7Miles }}</span>
                    </div>
                  </template>
                  <template v-else-if="offer.s7Miles">
                    <div class="booking-popup__s7">
                      <icon icon="s7" />
                      <span>+{{ offer.s7Miles }}</span>
                    </div>
                  </template>
                  <template v-if="offer.utairMiles">
                    <div class="booking-popup__utair">
                      <icon icon="utair" />
                      <span>+{{ offer.utairMiles }}</span>
                    </div>
                  </template>
                </div>
              </template>
              <div
                v-if="outOfPlaces"
                class="booking-popup__out-of-places u-text-center"
              >
                <div class="booking-popup__out-of-places-smile">😔</div>
                <div class="booking-popup__out-of-places-text font-semibold">
                  <div v-html="$t('bookingPopup.outOfPlaces.text.over')"></div>
                  <div class="u-text-secondary">
                    <span
                      v-html="$t('bookingPopup.outOfPlaces.text.leave')"
                    ></span>
                    <span
                      v-html="$t('bookingPopup.outOfPlaces.text.pick')"
                    ></span>
                  </div>
                </div>
                <yt-button
                  type="submit"
                  color="gray"
                  class="booking-popup__submit-button u-w-full"
                  :disabled="pending"
                  :squared = "true"
                >
                  {{ $t("bookingPopup.outOfPlaces.submit") }}
                </yt-button>
              </div>
              <template v-else>
                <booking-popup-fieldset
                  ref="bookingPopupFieldset"
                  :selected-offer.sync="$v.formData.offer.$model"
                  :offers="offers"
                  :is-custom-offer="customOfferSelected"
                  :participants.sync="$v.formData.participants.$model"
                  :offer="offer"
                  :pending="pending"
                  :is-offer-selected="offerSelected"
                  :is-show-min-price="isShowMinPrice"
                  :is-all-offers-loaded="isAllOffersLoaded"
                  :await-next-page="awaitNextPage"
                  class="booking-popup__fieldset"
                  @update:selectedOffer="$emit('update:selectedOffer',  {'isOfferSelected': true, 'formData': formData})"
                  @scroll-end="$emit('scroll-end')"
                />
                <div
                  class="booking-popup__left u-text-center"
                  :class="leftColorClasses"
                  v-if="!isShowMinPrice || (isShowMinPrice && offerSelected)"
                >
                  <button-icon tag="span">
                    <template v-if="leftLessThanHalf" #icon>
                      <icon icon="lightning" :class="leftColorClasses" />
                    </template>
                    <span class="font-semibold" v-html="leftText"></span>
                  </button-icon>
                </div>
                <div
                  v-if="offer.guarantee || tour.momental_book"
                  class="booking-popup__badges"
                >
                  <badge v-if="offer.guarantee" class="booking-popup__badge"
                         @tooltipShow="onTooltipShow($t('bookingPopup.badges.guarantee.title'));"
                         @tooltipHide="onTooltipHide($t('bookingPopup.badges.guarantee.title'));"
                  >
                    <span
                      v-html="$t('bookingPopup.badges.guarantee.title')"
                    ></span>
                    <template #tooltip>
                      <div class="u-text-center"
                        v-html="$t('bookingPopup.badges.guarantee.tooltip')"
                      ></div>
                    </template>
                  </badge>
                  <badge v-if="tour.momental_book" class="booking-popup__badge"
                         @tooltipShow="onTooltipShow($t('bookingPopup.badges.instant.title'));"
                         @tooltipHide="onTooltipHide($t('bookingPopup.badges.instant.title'));"
                  >
                    <span
                      v-html="$t('bookingPopup.badges.instant.title')"
                    ></span>
                    <template #tooltip>
                      <div class="u-text-center"
                        v-html="$t('bookingPopup.badges.instant.tooltip')"
                      ></div>
                    </template>
                  </badge>
                </div>
                <portal to="booking-popup-submit" :disabled="!sizeMdMax" slim>
                  <div class="booking-popup__submit">
                    <yt-button
                      v-if="!offerSelected && isShowMinPrice"
                      class="booking-popup__submit-button u-flex-shrink-0"
                      :disabled="bookingDisabled && !sizeMdMax"
                      @click="openMultiSelect"
                      :squared = "true"
                    >
                      {{ $t('bookingPopup.chooseDates') }}
                    </yt-button>
                    <yt-button
                      v-else
                      type="submit"
                      class="booking-popup__submit-button u-flex-shrink-0"
                      :disabled="bookingDisabled"
                      @click="trackClickActionButton"
                      :squared = "true"
                    >
                      {{ bookingButtonTitle }}
                    </yt-button>
                  </div>
                </portal>
                <div class="booking-popup__note u-text-center u-text-secondary">
                  <div
                    v-if="prepayPriceResult"
                    class="font-text-small"
                  >
                    {{ $t('bookingPopup.note.prepayment') }} - {{ prepayment }} {{ symbol }}
                  </div>
                  <div
                    v-else
                    class="font-text-small"
                    v-html="$t('bookingPopup.note.prepay')"
                  ></div>
                  <div v-if="offer.flexibleCancellation">
                    <span
                      class="font-text-small u-text-underline u-clickable"
                      v-html="$t('bookingPopup.note.flexible')"
                      @click="popups.flexible = true"
                    ></span>
                    <popup-flexible-cancellation v-model="popups.flexible" />
                  </div>
                  <div
                    v-else
                    class="font-text-small"
                    v-html="$t('bookingPopup.note.cancel')"
                  ></div>
                </div>
                <div
                  v-if="!!+tour.is_private"
                  class="booking-popup__individual"
                >
                  <span
                    class="
                      booking-popup__individual-trigger
                      font-semibold
                      u-text-green-dark u-clickable
                    "
                    v-html="$t('bookingPopup.individual.trigger')"
                    @click="triggerIndividualPopup()"
                  ></span>
                  <tooltip class="u-text-secondary"
                           @show="onTooltipShow($t('bookingPopup.individual.tooltipName'))"
                           @apply-hide="onTooltipHide($t('bookingPopup.individual.tooltipName'))"
                           wrap-after-text
                  >
                    <template #content>
                      <div class="u-text-center" v-html="$t(`bookingPopup.individual.tooltip`)"></div>
                    </template>
                  </tooltip>
                  <popup-individual v-model="popups.individual" :tour="tour" />
                </div>
              </template>
            </div>
          </div>
          <div v-if="isShowPopupBar" class="booking-popup__bar">
            <div v-if="outOfPlaces" class="font-semibold u-text-secondary">
              <div v-html="$t('bookingPopup.outOfPlaces.text.over')"></div>
              <div>
                <button
                  type="submit"
                  :disabled="pending"
                  class="booking-popup__out-of-places-submit font-semibold"
                  v-html="$t('bookingPopup.outOfPlaces.text.leave')"
                ></button>
                <span v-html="$t('bookingPopup.outOfPlaces.text.pick')"></span>
              </div>
            </div>
            <template v-else>
              <div class="booking-popup__bar-details u-flex-grow">
                <div
                  v-if="!isShowMinPrice || (isShowMinPrice && offerSelected)"
                  class="
                    booking-popup__bar-top
                    font-text-small
                    u-text-secondary
                  "
                >
                  <div>
                    {{ formData.participants }}&nbsp;{{
                      $t("bookingPopup.pers")
                    }}
                  </div>
                  <divider-dot v-if="offerSelected"/>
                  <dropdown-trigger
                    :extended="popupVisible"
                    class="booking-popup__bar-trigger"
                    @click="popupOpen = !popupOpen"
                  >
                    <template #label>
                      <span
                        class="font-text-small _ellipsis"
                        v-html="formData.offer.formattedRange"
                      ></span>
                    </template>
                  </dropdown-trigger>
                </div>
                <div class="booking-popup__bar-total font-h0">
                  <template v-if="(isShowMinPrice && !offerSelected)"
                  > {{ $t("bookingPopup.from") }} </template
                  >
                  {{ symbol }} {{ priceResultFormatted }}
                  <div
                    v-if="hasDiscount && isShowMinPrice && !offerSelected"
                    class="
                      booking-popup__prices-mob-original
                    "
                  >
                    {{ symbol }} {{ priceOriginalFormatted }}
                  </div>
                </div>
              </div>
              <portal-target name="booking-popup-submit" slim />
            </template>
          </div>
        </form>
        <div v-else :key="'preloader'" class="booking-popup__preloader">
          <div class="booking-popup__preloader-container">
            <preloader visible />
          </div>
        </div>
      </transition>
      <popup
        v-model="bookingPopupOpen"
        size="sm"
        @close="closeBookingPopupHandler"
      >
        <template v-if="!showRedirectPopupLoaded">
          <component
            class="booking-popup__add-order"
            :is="getComponentName"
            :userData="userData"
            @send-contact-submit = "sendContactBookingHandler"
            @loaded="loadedHandler"
          >
          </component>
          <preloader position="absolute" :visible="!popupLoaded" />
          <div v-show="showPopupLoaderBg"  class="popup-preloader-background"></div>
        </template>
        <component
          v-if="showRedirectPopup"
          :is="getRedirectPopup"
          :userData="userData"
          @redirect-submit="redirectHandler"
          @loaded="loadedHandler"
        />
        <div v-if="errorMessage" class="booking-popup__error">
          <div class="booking-popup__error-title">{{ $t("bookingPopup.error")}}</div>
          <div v-html="errorMessage" class="booking-popup__error-msg"></div>
          <yt-button
            class="popup-redirect__submit"
            color="green"
            :squared="false"
            @click="closeBookingPopupHandler"
          >
            OK
          </yt-button>
        </div>
      </popup>
    </div>
  </no-ssr>
</template>

<script>
import Cookies from "js-cookie";
import { i18n } from "@/plugins/i18n";
import { mapState, mapGetters } from "vuex";
import { sizeMdMax } from "@/assets/js/utils/mq";
import { required, maxValue, minValue } from "vuelidate/lib/validators";
import { axiosOrders } from "@/services/scopes/axios-orders";
import { axiosUser } from "@/services/scopes/axios-user";
import { parse, intervalToDuration } from "date-fns";

import getFormattedDateRange from "@/assets/js/utils/get-formatted-date-range";
import thousandsSeparator from "@/assets/js/utils/thousandsSeparator";
import BookingPopupFieldset from "@/components/organisms/booking-popup/fieldset.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import Icon from "@/components/icons/index.vue";
import Badge from "@/components/ui-kit/badge/index.vue";
import YtButton from "@/components/ui-kit/yt-button/index.vue";
import DividerDot from "@/components/ui-kit/divider-dot/index.vue";
import DropdownTrigger from "@/components/ui-kit/dropdown-trigger/index.vue";
import PopupFlexibleCancellation from "@/components/organisms/popup-flexible-cancellation/index.vue";
import Preloader from "@/components/ui-kit/preloader/index.vue";
import Tooltip from "@/components/ui-kit/tooltip/index.vue";
import PopupIndividual from "@/components/organisms/popup-individual/index.vue";
import PopupInstallment from "@/components/organisms/popup-installment/index.vue";
import noSSR from "vue-no-ssr";
import { ytEvents } from "@/plugins/analytics";
import Popup from "@/components/ui-kit/yt-popup";
import { abTestController } from "@/plugins/abtest";

export default {
  components: {
    Popup,
    BookingPopupFieldset,
    SvgInline,
    ButtonIcon,
    Icon,
    Badge,
    YtButton,
    DividerDot,
    DropdownTrigger,
    PopupFlexibleCancellation,
    Preloader,
    Tooltip,
    PopupIndividual,
    PopupInstallment,
    "no-ssr": noSSR,
  },
  props: {
    tour: {
      type: Object,
      required: true,
    },
    offerSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    formData: {
      type: Object,
      required: true,
    },
    offers: {
      type: Object,
      required: true,
    },
    offer: {
      type: Object,
      required: true,
    },
    isShowMinPrice: {
      type: Boolean,
      default: false,
    },
    isAllOffersLoaded: {
      type: Boolean,
      default: false,
    },
    awaitNextPage: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      pending: false,
      popupOpen: false,
      bookingPopupOpen: false,
      popups: {
        flexible: false,
        individual: false,
        installment: false,
      },
      popupLoaded: false,
      popupComponentName: '',
      showRedirectPopup: false,
      showRedirectPopupLoaded: false,
      paymentUrl: "",
      userData: {
        name: "",
        lastName: "",
        phone: "",
        email: ""
      },
      errorMessage: "",
      tooltipStartShowTime: [],
      trackingLabel: ""
    };
  },
  validations() {
    return {
      formData: {
        offer: {
          required,
        },
        participants: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(this.offer.freeSpaces),
        },
      },
    };
  },
  computed: {
    ...mapState("language", ["language"]),
    ...mapGetters("currency", ["symbol", "currencyId"]),
    ...mapGetters("user", ["getUserLoginStatus", "getUserContact"]),
    showPopupLoaderBg() {
      return (!this.showRedirectPopup && !this.popupLoaded) ||
        (
          this.showRedirectPopup &&
          !this.showRedirectPopupLoaded &&
          this.popupComponentName.length === 0
        );
    },
    datepickerLang() {
      return this.$t("dateSelector.datepickerLang");
    },
    minDays() {
      return this.days || 1;
    },
    minParticipants() {
      return this.formData.participants || 1;
    },
    priceOriginal() {
      return +this.offer.original_price * this.minParticipants;
    },
    priceOriginalFormatted() {
      return thousandsSeparator(this.priceOriginal);
    },
    priceResult() {
      if (this.customOfferSelected) {
        return +this.offer.price * this.minDays * this.minParticipants;
      }

      return +this.offer.price * this.minParticipants;
    },
    prepayPriceResult() {
      const prepayPrice = this.offer.prepay_price;

      if (!prepayPrice) {
        return null;
      }

      return +prepayPrice * this.minParticipants;
    },
    priceResultFormatted() {
      return thousandsSeparator(this.priceResult);
    },
    priceDay() {
      return (
        +(this.offer.price_day || this.tour.min_price) * this.minParticipants
      );
    },
    priceDayFormatted() {
      return thousandsSeparator(this.priceDay);
    },
    bonuses() {
      return parseInt(this.priceResult / 100 * this.userBonusLevel) ?? 0;
    },
    bonusesFormatted() {
      return thousandsSeparator(this.bonuses);
    },
    isShowBonuses() {
      return i18n.locale === "ru" && abTestController.getSegment(16449) === 'B';
    },
    isShowNewBookingPopups() {
      return abTestController.getSegment(15377) === 'B';
    },
    installmentAvailable() {
      return (
        this.currencyId === "rub" &&
        i18n.locale === "ru" &&
        !!this.tour.installment.available
      );
    },
    installmentPrice() {
      return +this.tour.installment.from;
    },
    installmentPriceFormatted() {
      return thousandsSeparator(this.installmentPrice);
    },
    hasDiscount() {
      return this.offer.discountValue && !this.customOfferSelected;
    },
    popupVisible() {
      return this.sizeMdMax && this.popupOpen;
    },
    leftLessThanHalf() {
      return (
        this.offer.freeSpaces <=
        this.offer.totalSpaces / 2
      );
    },
    leftColorClasses() {
      return this.leftLessThanHalf ? "u-text-violet-3" : "u-text-green-dark";
    },
    leftText() {
      const free = this.offer.freeSpaces;

      return this.$t("bookingPopup.left", {
        free: free > 0 ? free : 0,
        total: this.offer.totalSpaces,
      });
    },
    customOfferSelected() {
      return !!this.offer.custom;
    },
    days() {
      if (this.customOfferSelected) {
        const {
          offer: {range},
        } = this;

        if (range.length) {
          return (
            intervalToDuration({
              start: parse(range[0], "dd.MM.yyyy", new Date()),
              end: parse(range[1], "dd.MM.yyyy", new Date()),
            }).days + 1
          );
        }

        return 0;
      }
      return this.offer.period_date_days;
    },
    outOfPlaces() {
      return this.offers.length === 1 && this.offer.custom;
    },
    bookingAvailable() {
      return this.offer.freeSpaces > 0;
    },
    bookingDisabled() {
      return (
        this.pending || !this.bookingAvailable || this.$v.formData.$invalid || this.bookingPopupOpen
      );
    },
    easyBooking() {
      return (
        !this.getUserLoginStatus &&
        (this.language.id === "ru" ||
          (this.language.id === "en" &&
            Cookies.get("BITRIX_SM_YT12059AB") === "y"))
      );
    },
    bookingButtonTitle() {
      /**
       * book: "Забронировать",
       fullyPaid: "Тур оплачен",
       payTour: "Оплатить тур",
       postPayTour: "Оплатить остаток",
       bookAgain: "Забронировать снова",
       awaitConfirm: "Ожидает подтверждения",
       */

      const buttonAction = this.bookingData;
      return buttonAction.title;
    },
    prepayment() {
      return thousandsSeparator(this.prepayPriceResult);
    },
    bookingData() {
      /**
       * book: "Забронировать",
       fullyPaid: "Тур оплачен",
       payTour: "Оплатить тур",
       postPayTour: "Оплатить остаток",
       bookAgain: "Забронировать снова",
       awaitConfirm: "Ожидает подтверждения",
       */
      const orderActions = this.offer.orderActions;
      let data = {
        sessid: fakeWindow.BX?.bitrix_sessid(),
        title: this.$t(`bookingPopup.book`),
        operation_id: 'book',
        action: !this.getUserLoginStatus ? 'ContactSandBook' : 'BookTour',
        init_action: 'BookTour',
        trigger: 'action',
        data: {
          date: this.formData.offer.id,
          template: "easybooktour",
          trip_id: this.tour.id,
          "people-counter": this.formData.participants,
        },
        backurl: fakeWindow.location?.pathname,
      };

      if (orderActions.haveOrder
        && !orderActions.isPrepaid
        && !orderActions.isPostpaid
      ) {
        data = {
          ...data,
          ...{
            title: this.$t(`bookingPopup.payTour`),
            action: 'link',
            url: orderActions.prePayUrl,
            operation_id: 'payTour',
          }
        };
      }

      if (orderActions.isPrepaid
        && !orderActions.isPostpaid
        && this.offer.collectPostPay
      ) {
        data = {
          ...data,
          ...{
            title: this.$t(`bookingPopup.postPayTour`),
            action: 'link',
            url: orderActions.postPayUrl,
            operation_id: 'postPayTour',
          }
        };
      }

      if (orderActions.haveOrder
        && orderActions.awaitForConfirmation
        && orderActions.isPrepaid
      ) {
        data = {
          ...data,
          ...{
            title: this.$t(`bookingPopup.awaitConfirm`),
            operation_id: 'awaitConfirm',
            init_action: 'WaitConfirm',
            action: 'ShowScreen',
            data: {'template': 'waitconfirm'},
          }
        };
      }
      return data;
    },
    getRedirectPopup() {
      if (this.bookingPopupOpen) {
        return () => import(`@/components/organisms/booking_popups/popup-redirect/index.vue`);
      }
      return "";
    },
    getComponentName() {

      if (this.bookingPopupOpen) {
        if (this.popupComponentName.length) {
          return () => import(`@/components/organisms/booking_popups/popup-${this.popupComponentName}/index.vue`);
        }
      }
      return "";
    },
    sizeMdMax,
    isShowPopupBar() {
      if (!this.isShowMinPrice) {
        return this.sizeMdMax
      } else {
          if (this.sizeMdMax && this.popupOpen) {
            return !this.$refs.bookingPopupFieldset?.$refs?.multiselectOffers?.$refs?.multiselect.isOpen
          }
        return this.sizeMdMax
        }
      }
    },
    mounted() {
      fakeWindow.addEventListener("yt.putModalContent", this.onPutModalContent);
    },
    beforeDestroy() {
      fakeWindow.removeEventListener("yt.putModalContent", this.onPutModalContent);
    },
    watch: {
      "formData": {
        deep: true,
        handler(value) {
          this.$emit("changeFormData", value);
        }
      },
      offer: {
        deep: true,
        handler(offer) {
          this.$emit("change", {...offer});
        },
      },
    },
    methods: {
      async pick() {
        if (this.pending) {
          return;
        }

        this.popupComponentName = 'help-me';
        this.pending = true;
        this.bookingPopupOpen = true;
      },
      async book() {
        this.$v.formData.$touch();

        if (this.bookingDisabled) {
          return;
        }

        if (this.bookingData.action === 'link') {
          fakeWindow.location.href = this.bookingData.url;
          return;
        }

        this.pending = true;

        if (!this.isShowNewBookingPopups && this.bookingData.action == 'BookTour') {
          let ytObj = youtravel || {};
          if (typeof ytObj.ModalController !== "undefined") {
            this.bookingData.tracking_label = this.trackingLabel;
            ytObj.ModalController.openModal({
              ajax_mode: true,
              ajax_type: "POST",
              ajax_url: "/local/ajax/booking/ajax.booking.php",
              bodyRequest: this.bookingData,
            });
          }
        } else {
          // Авторизованному телефон не обязателен (в т.ч. после identify) — не открываем send-phone.

          this.bookingPopupOpen = true;

          if (!this.getUserLoginStatus) {

            const userInfo = await axiosOrders.getUserData()
              .then(({data}) => {
                if (data.success) {
                  return data.data
                }
              })

            this.userData.name = userInfo.name || "";
            this.userData.lastName = userInfo.last_name || "";
            this.userData.email = userInfo.email || "";
            this.userData.phone = userInfo.personal_phone || "";

            if (this.userData.email
              && this.userData.phone.length == 0
              && this.userData.name
              && this.userData.lastName
            ) {
              this.popupComponentName = 'send-phone';
            } else {
              this.popupComponentName = 'send-contact';
            }
          }

          if (this.popupComponentName.length == 0) {
            const phoneFormated = this.getUserContact.personalPhone || this.userData.phone || ""
            const orderData = {
              "tourId": this.tour.id,
              "peopleCounter": this.getParticipantsCount(),
              "date": this.formData.offer.id,
              "from": "",
              "to": "",
              "message": "",
              "type": "default",
              "user": {
                "name": this.getUserLoginStatus ? "" : this.userData.name,
                "lastName": this.getUserLoginStatus ? "" : this.userData.lastName,
                "email": this.getUserContact.email || this.userData.email,
                "phone": phoneFormated.replaceAll(' ', '').replaceAll('+', '')
              }
            };
            this.popupLoaded = false;
            this.showRedirectPopupLoaded = false;
            this.showRedirectPopup = true
            await this.addOrder(orderData);
          }
        }

      },
      preparePhone(phone) {
        return phone.replaceAll(' ', '').replaceAll('+', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '')
      },
      closeBookingPopupHandler() {
        this.bookingPopupOpen = false;
        this.pending = false;
        this.popupLoaded = false;
        this.showRedirectPopupLoaded = false;
        this.showRedirectPopup = false;
        this.popupComponentName = "";
        this.errorMessage = '';
      },
      async sendContactBookingHandler(evt) {
        const tourId = this.tour.id;
        const offerId = this.formData.offer.id;
        const peopleCounter = this.getParticipantsCount();
        const {popup, value} = evt;
        this.showRedirectPopup = true;
        this.popupLoaded = false;
        this.showRedirectPopupLoaded = false;
        let userData, orderData = {};
        if (popup == 'send-phone') {
          userData = {
            name: this.userData.name,
            last_name: this.userData.lastName,
            personal_phone: this.preparePhone(value.phone),
            email: this.userData.email,
          };
          orderData = {
            "tourId": tourId,
            "peopleCounter": peopleCounter,
            "date": offerId,
            "from": "",
            "to": "",
            "message": "",
            "type": "default",
            "user": {
              "name": "",
              "lastName": "",
              "email": this.getUserContact.email,
              "phone": this.preparePhone(value.phone)
            }
          };
          await axiosUser.UpdateFields({
            "data": {
              personalPhone: userData.personal_phone
            }
          }).then(({data}) => {
            if (data.success) {
              ytEvents.trackEventRrApiSetEmail(userData.email, i18n.locale);
            }
          })
            .catch(function (error) {
              console.log("error", error);
            });
        }

        if (popup == 'send-contact') {
          userData = {
            name: value.name,
            last_name: value.lastName,
            personal_phone: this.preparePhone(value.phone),
            email: value.email
          };
          orderData = {
            "tourId": tourId,
            "peopleCounter": peopleCounter,
            "date": offerId,
            "from": "",
            "to": "",
            "message": "",
            "type": "default",
            "user": {
              "name": value.name,
              "lastName": value.lastName,
              "email": value.email,
              "phone": this.preparePhone(value.phone)
            }
          };
        }

        await axiosOrders.updateUserData({
          "value": userData
        }).then(({data}) => {
          if (data.success) {
            ytEvents.trackEventRrApiSetEmail(userData.email, i18n.locale);
            this.addOrder(orderData);
          }
        }).catch(function (error) {
          console.log("error", error);
        });
      },

      async addOrder(orderData) {
        let context = this;

        await axiosOrders.orderAdd('default', orderData)
          .then(({data}) => {
            if (data.success) {
              let ytCommission = this.formData.offer.commission * orderData.peopleCounter || 0;
              this.errorMessage = '';
              this.trackEvents("Tour detail", "Booking created", `order_id=${data.data.orderId};place=${this.trackingLabel}`);
              if (typeof window.youtravel.DataCollector !== "undefined") {
                window.youtravel.DataCollector.trackEvent("Tour detail", "Booking created", {
                  'tour_id': this.tour.id || "",
                  'list': "",
                  'filter': {},
                  'additional': {
                    "order_id": data.data.orderId,
                    "place": this.trackingLabel,
                  },
                  'meta': {}
                })
              }
              this.trackEvents("Show Success booking popup", "Booking Popup", 'success');
              this.trackEvents('booking', 'want_to_go', '', {
                tour_id: this.tour.id,
                location: this.tour.country
              });
              try {
                ytEvents.trackEventRrApiAddToBasket(this.tour.id, i18n.locale);
              } catch (e) {
                console.log("error", e);
              }
              ytEvents.trackFbq(
                "AddToCart",
                {
                  content_ids: [`TOUR-${this.tour.id}`],
                  content_type: 'product',
                  google_event: 'booking',
                  value: ytCommission,
                  currency: this.tour.currency.toUpperCase()
                },
                'AddToCartId'
              );
              ytEvents.trackVk(this.tour.id, this.formData.offer.priceValue, this.tour.currency, ytCommission);
              fakeWindow.dataLayer = fakeWindow.dataLayer || [];
              fakeWindow.dataLayer.push({
                'ecommerce': {
                  'currencyCode': this.tour.currency.toUpperCase(),
                  'add': {
                    'products': [{
                      'name': this.tour.name,
                      'id': `TOUR-${this.tour.id}`,
                      'price': this.formData.offer.priceValue,
                      'brand': `EXPERT-${this.tour.expert_id}`,
                      'variant': data.data.date_variant ? data.data.date_variant : 'No variant',
                      'quantity': orderData.peopleCounter,
                      'dimension4': `${this.tour.country} ${this.tour.region.lenght ? ', ' + this.tour.region.lenght : ''}`,
                      'dimension9': this.tour.type
                    }]
                  }
                },
                'event': 'gtm-ee-event',
                'gtm-ee-event-category': 'Enhanced Ecommerce',
                'gtm-ee-event-action': 'Adding a Product to a Shopping Cart',
                'gtm-ee-event-non-interaction': 'False',
              });
              fakeWindow.dataLayer.push({
                'value': ytCommission > 0 ? ytCommission : this.formData.offer.priceValue,//'<?=$iYtCommission ?: $iTourPrice?>',
                'items': [{
                  'destination': `TOUR-${this.tour.id}`,
                  'google_business_vertical': 'travel'
                }],
                'event': 'add_to_cart'
              });
              this.trackingLabel = '';

              this.paymentUrl = `/lk/pay/?tour_id=${this.tour.id}&order_id=${data.data.orderId}`
            }
          })
          .catch(({response}) => {
            context.showRedirectPopup = false;
            context.errorMessage = response.data.data.message;
            this.trackEvents("Show Booking error popup", "Booking Popup", context.errorMessage);
          });
      },
      redirectHandler() {
        fakeWindow.location.href = this.paymentUrl;
      },
      triggerIndividualPopup() {
        this.trackEvents("Booking Popup", "Click Submit request as private button");
        if (this.getUserLoginStatus) {
          this.popups.individual = true;
        } else {
          fakeWindow.showVueAuthModal({"emit-event": "popup-individual"});
        }
      },
      triggerInstallmentPopup() {
        this.popups.installment = true;
      },
      onSubmit(trackingLabel = '') {
        if (this.outOfPlaces) {
          this.pick();
          return;
        }

        if (this.bookingAvailable) {
          this.trackingLabel = trackingLabel;
          this.book();
        }
      },
      getDisabledCustomDates(date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return date < today;
      },
      onPutModalContent() {
        this.pending = false;
      },
      scrollToImportant() {
        this.$scrollTo("#tour-important", 500);
      },
      getParticipantsCount() {
        const participants = localStorage.getItem('participants');

        return participants === null || isNaN(+participants) ? this.formData.participants : +participants;
      },
      getFormattedDateRange,
      trackClickActionButton() {
        let operation = 'Reserve';
        this.trackingLabel = 'Tour detail';
        switch (this.bookingData.operation_id) {
          case 'book':
            operation = 'Reserve';
            break;
          case 'payTour':
            operation = 'Go to payment';
            break;
          case 'postPayTour':
            operation = 'Go to post-payment';
            break;
          case 'awaitConfirm':
            operation = 'Confirmation';
            break;
        }

        this.trackEvents("Tour detail Booking", "Click Action button", operation);
        this.trackEvents("Tour detail", "Click Booking button", this.trackingLabel);
        if (typeof window.youtravel.DataCollector !== "undefined") {
          window.youtravel.DataCollector.trackEvent("Tour detail Booking", "Click Action button", {
            'tour_id': this.tour.id || "",
            'list': "",
            'filter': {},
            'additional': {
              "action": operation,
            },
            'meta': {}
          })
          window.youtravel.DataCollector.trackEvent("Tour detail", "Click Booking button", {
            'tour_id': this.tour.id || "",
            'list': "",
            'filter': {},
            'additional': {
              "action": this.trackingLabel,
            },
            'meta': {}
          })
        }
      },
      trackEvents(cat, name, lbl, props) {
        ytEvents.track(cat, name, lbl, props);
      },
      loadedHandler() {
        this.popupLoaded = true;
        if (this.showRedirectPopup) {
          this.showRedirectPopupLoaded = true;
        }
      },
      openMultiSelect() {
        if (!this.sizeMdMax) {
          this.trackEvents("Tour detail Booking", "Click Action button", "Choose Dates");
          this.$refs.bookingPopupFieldset.$refs.multiselectOffers.$refs.multiselect.activate()
        } else {
          if (!this.popupOpen) {
            this.popupOpen = true;
          } else {
            this.trackEvents("Tour detail Booking", "Click Action button", "Choose Dates");
            this.$refs.bookingPopupFieldset.$refs.multiselectOffers.$refs.multiselect.activate()
          }
        }
      },
      onTooltipShow(name) {
        this.trackEvents('Tour detail', 'Show description tooltip', name);
        this.tooltipStartShowTime[name] = Date.now();
      },
      onTooltipHide(name) {
        const tooltipShowTime = (Date.now() - this.tooltipStartShowTime[name]) / 1000;
        this.trackEvents('Tour detail', 'Hide description tooltip', name, {showTime: tooltipShowTime});
      }
    },
};
</script>

<style lang="scss" scoped>
$b: ".booking-popup";

#{$b} {
  background: var.$white;

  @include mixin.size-md {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99999;
  }

  @include mixin.size-lg-min {
    box-shadow: 1px 3px 60px rgba(var.$secondary, 0.35);
    border-radius: var.$rounded-20;
  }

  &__wrapper {
    background: var.$white;

    @include mixin.size-md {
      position: fixed;
      top: -100px;
      right: 0;
      bottom: -100px;
      left: 0;
      padding: 100px 0 180px;
      display: flex;
      justify-content: center;
      transition: var.$transition-default;

      #{$b}:not(._popup-visible) & {
        opacity: 0;
        visibility: hidden;
      }
    }

    @include mixin.size-lg-min {
      border-radius: var.$rounded-20;
    }

    &-container {
      padding: 20px var.$inner-pd 32px;

      @include mixin.size-md {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 440px;
        overflow-y: auto;
      }

      @include mixin.size-lg-min {
        padding: 20px 24px 28px;
      }
    }
  }

  &__error {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    &-msg {
      margin-bottom: 30px;
    }
    &-title {
      padding: 0 0 27px 0;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px;
      text-align: center;
    }
  }

  &__prices {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 8px;
    cursor: pointer;

    &-original,
    &-result {
      font-size: 24px;
    }

    &-mob-original {
      color: var(--grey-text, #9999A9);
      font-family: "SF Pro Text";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px; /* 128.571% */
      letter-spacing: -0.28px;
      text-decoration-line: line-through;
    }

    &-original {
      text-decoration: line-through;
      margin-right: 8px;
    }

    &-result {
      &:not(:last-child) {
        margin-right: 12px;
      }
    }

    &-discount {
      font-weight: bold;
      font-size: 11px;
      line-height: func.divide(12, 11);
      letter-spacing: 0.02em;
      color: var.$white;
      background: var.$red;
      padding: 6px;
      border-radius: var.$rounded-4;
      margin: 2px 0;
    }
  }

  &__s7 {
    display: flex;
    color: #9AAE2D;
    margin-left: auto;
    align-items: center;

    span {
      font-weight: 600;
      font-size: 13px;
      line-height: 17px;
      letter-spacing: -0.02em;
      margin-left: 4px;
    }
  }

  &__c7 {
    color: #ffffff !important;
    background: #C4D600 !important;
    display: inline-block !important;
    border-radius: 8px !important;
    padding: 4px 8px !important;
    font-size: 12px !important;
    margin-left: auto;

    svg{
      position: relative;
      top: 2px;
    }
  }

  &__utair {
    display: flex;
    color: #003494;
    margin-left: 16px;
    align-items: center;

    span {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: -0.02em;
      margin-left: 4px;
    }
  }


  &__installment {
    background: #ffd700;
    border-radius: 6px;
    width: fit-content;
    padding: 3.5px 6px;
    margin-bottom: 8px;
    cursor: pointer;

    & > span {
      padding-right: 22px;
    }
  }

  &__days {
    display: flex;
    align-items: center;
  }

  &__bonuses {
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-bottom: 8px;

    &-text {
      color: #8427bd;
    }

    &-tooltip {
      margin-left: 2px;
    }
  }

  &__fieldset {
    margin-top: 28px;

    @include mixin.size-lg-min {
      margin-top: 20px;
    }
  }

  &__left {
    margin-top: 12px;
  }

  &__badges {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 32px 0px 0;
    flex-direction: column;
    gap: 6px;
    @include mixin.size-lg-min {
      flex-direction: row;
    }
  }

  &__badge {
  }

  &__submit {
    @include mixin.size-lg-min {
      margin-top: 20px;
    }

    #{$b}__submit-button {
      @include mixin.size-sm {
        padding: 0 15px;
      }

      @include mixin.size-lg-min {
        width: 100%;
      }
    }
  }

  &__note {
    margin-top: auto;
    padding-top: 24px;

    .font-text-small--prepay {
      line-height: 18px;
    }
  }

  &__out-of-places {
    &-smile {
      font-size: 40px;
      line-height: 1;
      margin-bottom: 10px;
    }

    &-text {
      margin-bottom: 28px;
    }

    &-submit {
      @include mixin.button-reset();
      text-decoration: underline;
    }
  }

  &__bar {
    position: relative;
    display: flex;
    align-items: center;
    padding: 15px var.$inner-pd;
    border-top: 1px solid var.$gray-light;
    box-shadow: 1px 4px 20px rgba(var.$secondary, 0.35);
    background: var.$white;

    @include mixin.size-md-min {
      padding: 15px 2 * var.$inner-pd;
    }

    &-details {
      margin-right: var.$inner-pd * 0.5;
    }

    &-top {
      display: flex;
      align-items: center;
      margin-bottom: 4px;
    }

    &-trigger {
      color: var.$secondary;
    }

    &-total {
      font-size: 24px;
    }
  }

  &__close {
    @include mixin.button-reset();
    position: absolute;
    top: 124px;
    right: 20px;
    width: 12px;

    &::before {
      @include mixin.full-pos(-50%);
      position: absolute;
      display: block;
      content: "";
    }
  }

  &__preloader {
    padding: 15px;

    @include mixin.size-md {
      background: var.$white;
      box-shadow: 1px 4px 20px rgba(var.$secondary, 0.35);
    }

    @include mixin.size-lg-min {
      padding: 20px;
    }

    &-container {
      @include mixin.size-md {
        max-width: 48px;
        margin: 0 auto;
      }
    }
  }

  &__individual {
    border-top: 1px solid var.$gray-light;
    margin-top: 24px;
    padding-top: 20px;
    text-align: center;

    &-trigger {
      padding-right: 28px;
    }
  }

  &__add-order {
    min-height: 50px;
    z-index: 1;
    position: relative;
  }
}
.popup-preloader-background{
  height: 50px;
  width:100%;
}

._ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  @media (max-width: 400px) {
    max-width: calc(100vw - 255px);
  }
}
</style>
